<div class="message">
  @if (message().thought && !message().text) {
    <div class="thinking"><markdown [data]="message().thought"></markdown></div>
  }
  <div class="response">
    <div class="text"><markdown clipboard [data]="message().text"></markdown></div>
    @if (message().status) {
      <div class="notice" role="status">{{ message().status }}</div>
    }
    <div class="footer">
      @if (isStreaming()) {
        @if (message().waitingForTool) {
          <div class="tool-wait" role="status">
            <span class="tool-wait-spinner" aria-hidden="true"></span>
            <span>Waiting for the tool run</span>
          </div>
        } @else {
          <div class="typing"><span>.</span><span>.</span><span>.</span></div>
        }
      } @else {
        <div class="actions">
          <button
            cuiButton
            square
            size="small"
            variant="plain"
            type="button"
            (click)="onCopy()"
            matTooltip="Copy"
            aria-label="Copy response">
            <span class="material-symbols-outlined" aria-hidden="true">content_copy</span>
          </button>
        </div>
      }
    </div>
  </div>
</div>
